import { api } from './api';

// Define account service
export const accountApi = api.injectEndpoints({
  reducerPath: 'accountApi',
  tagTypes: ['Accounts'],
  endpoints: (builder) => ({
    getAccounts: builder.query({
      query: () => ({
        url: `/api/administration/accounts`,
        method: 'GET'
      }),
      providesTags: ['Accounts']
    }),
    createAccount: builder.mutation({
      query: (accountRequest) => ({
        url: `/api/administration/accounts`,
        method: 'POST',
        body: accountRequest
      }),
      invalidatesTags: ['Accounts']
    }),
    updateAccount: builder.mutation({
      query: ({ accountId, accountRequest }) => ({
        url: `/api/administration/accounts/${accountId}`,
        method: 'PATCH',
        body: accountRequest
      }),
      invalidatesTags: ['Accounts']
    }),
    deleteAccount: builder.mutation({
      query: (accountId) => ({
        url: `/api/administration/accounts/${accountId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Accounts']
    }),
    bulkDeleteAccounts: builder.mutation({
      query: (accountIds) => ({
        url: `/api/administration/accounts`,
        method: 'DELETE',
        body: accountIds
      }),
      invalidatesTags: ['Accounts']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAccountsQuery,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useDeleteAccountMutation,
  useBulkDeleteAccountsMutation
} = accountApi;
